import apiClient from '@/config/api';

/** 광고 네트워크 원격 설정 (app_versions.ad_config) */
export interface AdConfig {
  /** 노출 우선순위. 예: ['cauly', 'admob'] — 앞에서부터 시도, 실패 시 다음으로 폴백 */
  order: string[];
  cauly?: { code: string };
  admob?: { nativeId: string };
}

/** 종목별 원격 설정 항목 (app_versions.sport_config 배열의 원소) */
export interface SportConfigItem {
  /** 종목 식별값 — 변경 불가 (예: 'GOLF', 'BOWLING') */
  value: string;
  /** 앱에 표시할 종목명 */
  label: string;
  /** 노출 여부 */
  visible: boolean;
}

export interface AppVersion {
  id: string;
  platform: string; // IOS, ANDROID
  minVersion: string;
  latestVersion: string;
  latestBuild: number;
  forceUpdate: boolean;
  updateMessage: string | null;
  storeUrl: string | null;
  showAd: boolean;
  adConfig: AdConfig | null;
  sportConfig: SportConfigItem[] | null;
  createdAt: string;
  updatedAt: string;
}

export interface PatchAppVersion {
  minVersion?: string;
  latestVersion?: string;
  latestBuild?: number;
  forceUpdate?: boolean;
  updateMessage?: string | null;
  storeUrl?: string | null;
  showAd?: boolean;
  adConfig?: AdConfig | null;
  sportConfig?: SportConfigItem[] | null;
}

export const appVersionsApi = {
  async list(): Promise<AppVersion[]> {
    const res = await apiClient.get('/admin/app-versions');
    return res.data.data as AppVersion[];
  },
  async update(id: string, body: PatchAppVersion): Promise<AppVersion> {
    const res = await apiClient.patch(`/admin/app-versions/${id}`, body);
    return res.data.data as AppVersion;
  },
};
